import { useScrollFadeIn } from '../../../hooks/useScrollFadeIn';

export default function ImageShowcase() {
  const { ref, isVisible } = useScrollFadeIn({ delay: 200 });

  return (
    <section
      ref={ref}
      className={`bg-[#080808] py-20 md:py-32 px-5 md:px-10 transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="max-w-6xl mx-auto">
        {/* セクションラベル */}
        <div className="flex justify-center mb-6 md:mb-8">
          <span className="text-[10px] tracking-[0.4em] uppercase text-white/30 font-semibold">
            Lifestyle
          </span>
        </div>

        {/* コピーエリア（上部） */}
        <div className="text-center mb-10 md:mb-16">
          <p className="text-[10px] tracking-[0.4em] uppercase text-white/30 font-semibold mb-3 md:mb-4">
            Designed for your life
          </p>
          <h3 className="text-2xl md:text-4xl font-black text-white leading-snug mb-4 md:mb-5">
            仕事も、遊びも。<br />
            <span className="text-white/50">ずっと、快適に。</span>
          </h3>
          <p className="text-sm md:text-sm text-white/40 leading-relaxed max-w-md mx-auto px-2">
            長時間のデスクワークから深夜のゲームセッションまで、
            あらゆるシーンに溶け込む一脚。
          </p>
        </div>

        {/* 2枚の正方形画像 横並び */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {/* 左：元の画像 */}
          <div className="relative overflow-hidden rounded-2xl group">
            <div className="w-full aspect-square">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/14ee8276a2ce85bd9c1cb11349298840.jpeg"
                alt="MeVER Chair Pro v2.0 ライフスタイルイメージ"
                className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>
          </div>

          {/* 右：新しい画像（ギター） */}
          <div className="relative overflow-hidden rounded-2xl group">
            <div className="w-full aspect-square">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/6dad232f27219866e1d2ff0737c45e1d.jpeg"
                alt="MeVER Chair Pro v2.0 デスク環境イメージ"
                className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            </div>
          </div>
        </div>

        {/* CTAエリア */}
        <div className="mt-12 md:mt-20 flex flex-col items-center gap-4 md:gap-5">
          <p className="text-[11px] tracking-[0.35em] uppercase text-white/30 font-semibold">
            Limited Offer
          </p>
          <h4 className="text-xl md:text-3xl font-black text-white text-center leading-snug px-4">
            先行予約、受付中。<br />
            <span className="text-white/40 text-base md:text-xl font-medium">各色50脚限定・30%OFF</span>
          </h4>
          <a
            href="https://mever.design/products/mever-chair-pro-ver2"
            target="_blank"
            rel="noopener noreferrer"
            className="group w-full md:w-auto inline-flex items-center justify-center gap-3 px-10 py-4 md:px-14 md:py-5 bg-white hover:bg-white/90 text-gray-900 text-base md:text-lg font-bold rounded-full transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 active:scale-[0.97] whitespace-nowrap cursor-pointer min-h-[56px]"
          >
            <span>今すぐ予約する</span>
            <span className="w-5 h-5 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
              <i className="ri-arrow-right-line text-lg"></i>
            </span>
          </a>
          <div className="flex items-center gap-2 md:gap-3 flex-wrap justify-center text-center px-4">
            <span className="text-xs md:text-xs text-white/30">通常価格 <span className="line-through">¥128,700</span></span>
            <span className="text-white/20">→</span>
            <span className="text-sm md:text-sm font-bold text-white/80">¥89,650</span>
            <span className="text-white/20">／</span>
            <span className="text-xs md:text-xs text-white/30">発送：4月下旬〜5月上旬</span>
          </div>
        </div>

      </div>
    </section>
  );
}